import { MessagingClient } from "@whatslly/commons/messagingClient";
import type { WebScriptCommandsTypes } from "@whatslly/commons/webScriptCommands";
import { WebScriptCommands } from "@whatslly/commons/webScriptCommands";
export const webScriptClient = new MessagingClient<WebScriptCommandsTypes>(WebScriptCommands);
